import { render, staticRenderFns } from "./OrderModePopUp.vue?vue&type=template&id=b83afa88&scoped=true&"
import script from "./OrderModePopUp.vue?vue&type=script&lang=js&"
export * from "./OrderModePopUp.vue?vue&type=script&lang=js&"
import style0 from "./OrderModePopUp.vue?vue&type=style&index=0&id=b83afa88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83afa88",
  null
  
)

export default component.exports